import { displayNotImplemented } from "../../../services/Notifications/NotificationServices";

interface NotImplementedWrapProps {
  children: React.ReactNode;
}

export default function NotImplementedWrap({ children }: NotImplementedWrapProps) {
  return (
    <div onClick={displayNotImplemented} style={{ display: "inline-block" }}>
      <div style={{ pointerEvents: "none" }}>{children}</div>
    </div>
  );
}
